import React from 'react';

const PageNotFoundComponent = () => (
  <div>Page Not Found</div>
);

export default PageNotFoundComponent;
